import { configureStore } from '@reduxjs/toolkit';
import { optOutSlice } from './slice.ts';
import { api } from './api.ts';

export const store = configureStore({
  reducer: {
    [optOutSlice.reducerPath]: optOutSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
